
import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../styling/Dashboard.css";
import "../../styling/ClientPortal.css";
import { useProfile } from "../../ProfileContext";
import { useRef } from "react";
import { FaUpload } from "react-icons/fa";
import { FaUserCircle } from "react-icons/fa";
import coverImage from "../../images/Profile-Banner.png";


const LeftPanelClientPortal = ({
  handleBackToAccount,
  clientData,
  brandingColours,
  selectedTab,
}) => {
  const primaryColor = "black";

  const [clientDetails, setClientDetails] = useState("");


  const buttonStyle = {
    display: "inline-block",
    padding: "10px, 20px",
    background: brandingColours?.primaryColor,
    color: brandingColours?.secondaryColor,
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    width: "75%",
    height: "35px",
    fontSize: "15px",
    border: "1px solid #d4d4d4",
  };

  const cancelButtonStyle = {
    padding: "10px, 20px",
    background: brandingColours?.primaryColor,
    color: brandingColours?.secondaryColor,
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    width: "75%",
    height: "35px",
    fontSize: "15px",
  };

  const openCancellationModal = {};
  const { clientProfileImage, setClientProfileImage } = useProfile();

  useEffect(() => {
    const fetchClientDetails = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/clientDetails/${clientData._id}`,
          { withCredentials: true }
        );

        setClientDetails(response.data.data);

        console.log("Client details fetched:", response.data.data);
        setClientProfileImage(response.data.data.profilePic);

      } catch (error) {
        console.log("Error fetching client details:", error);
      }
    };

    if (clientData?._id) {
      fetchClientDetails();
    }
  }, [clientData?._id, setClientProfileImage]);

  // const [profileImage, setProfileImage] = useState(clientDetails.profilePic);


  const clientAccountRef = useRef(null);
  const handleClientImageButtonClick = () => {
    clientAccountRef.current.click();
  };
  const handleClientImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("profilePic", file);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/client/upload-profile`,
        formData,
        {
          withCredentials: true,
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
   
      if (response.data.profilePic) setClientProfileImage(response.data.profilePic);
      console.log("Image set");
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const clientInfo = (
    <div>
      <img
        src={coverImage}
        alt="cover"
        style={{ width: "100%", height: "150px" }}
      />
      <div className="clientProfileContainer">
        <div className="clientProfileImage">
          {/* <img
            src={profileImage || clientDetails.profilePic}
            alt="Profile"
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "70%",
              overflow: "hidden",
              marginTop: "-28px",
            }}
          /> */}

          {/* {profileImage ? (
            <img
              src={profileImage}
              alt="Profile"
              style={{
                width: "60px",
                height: "60px",
                borderRadius: "70%",
                overflow: "hidden",
                marginTop: "-28px",
              }}
            />
          ) : (
            <FaUserCircle
              size={60}
              color="#bfbfbf"
              style={{ marginTop: "-28px" }}
            />
          )} */}


          <div
              style={{
                position: "relative",
                // bottom: "-25px",
                marginTop:'-20px',
                // left: "15px",
                width: "60px",
                height: "60px",
                borderRadius: "50%",
                overflow: "hidden",
                backgroundColor: "#ffffff",
                border: "2px solid #ffffff",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                // marginBottom: "120px",
              }}
            >
              {clientProfileImage? (
                <img
                  src={clientProfileImage}
                  alt="Profile"
                  style={{
                    width: "110%",
                    height: "110%",
                    objectFit: "cover",
                    transform: "translate(-5%, -5%)",
                  }}
                />
              ) : (
                <FaUserCircle size={47} color="#bfbfbf" />
              )}
            </div>

        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginRight: "25px",
          }}
        >
          <h2
            style={{
              marginLeft: "25px",
              marginRight: "25px",
              color: primaryColor,
            }}
          >
            {clientDetails && clientDetails.name ? clientDetails.name : ""}
          </h2>

          <input
            type="file"
            style={{ display: "none" }}
            ref={clientAccountRef}
            onChange={handleClientImageUpload}
          />
          {/* <button
            style={{
              width: "25%",
              height: "40px",
              fontSize: "14px",
              background: "#FFFFFF",
              border: "1px solid #D9D9D9",
              color: "#1C1154",
              cursor: "pointer",
            }}
            onClick={handleClientImageButtonClick}
          >
            Edit
          </button> */}
        </div>

        <div
          className="clientDataPanel"
          style={{
            marginLeft: "25px",
            marginRight: "25px",
            fontWeight: "500",
            color: primaryColor,

          }}
        >
          {/* Phone */}
          <div>
            <h4 style={{ marginBottom: "-5px" }}>Phone</h4>
            <p style={{ color: "#625C73" }}>
              {clientData && clientData.phone ? clientData.phone : "N/A"}
            </p>
          </div>

          {/* Email */}
          <div>
            <h4 style={{ marginBottom: "-5px" }}>Email</h4>
            <p style={{ color: "#625C73" }}>
              {clientData && clientData.email ? clientData.email : "N/A"}
            </p>
          </div>

          {/* Most Recent Booking */}
          <div>
            <h4 style={{ marginBottom: "-5px" }}>Most Recent Booking</h4>
            <p style={{ color: "#625C73" }}>
              {clientDetails?.mostRecentEventDate
                ? new Date(
                    clientDetails.mostRecentEventDate
                  ).toLocaleDateString()
                : ""}
            </p>
          </div>

          {/* Total Events Booked */}
          <div>
            <h4 style={{ marginBottom: "-5px" }}>Total Events Booked</h4>
            <p style={{ color: "#625C73" }}>{clientDetails.numberOfEvents}</p>
          </div>
        </div>
        {selectedTab !== "landing" && (
          <div
            style={{
              marginLeft: "25px",
              paddingBottom: "10px",
            }}
            className="clientDataPanelButtons"
          >
            <button
              style={buttonStyle}
              onClick={handleBackToAccount}
              className="events-button-hover-underline"
            >
              View All Events
            </button>
            <button
              style={cancelButtonStyle}
              onClick={openCancellationModal}
              className="cancel-reschedule-btn"
            >
              Cancel or Reschedule
            </button>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <div>
      <div>{clientInfo}</div>
    </div>
  );
};

export default LeftPanelClientPortal;
